
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as errori8Oj04PNGHE0g64_VR8XJJtKjvOeRBCWLniyWd9O2GQMeta } from "/webapp/pages/error.vue?macro=true";
import { default as callbackiqkAWtEtKCc8PFpeSObmO55zJQBK8pmislls6j5N8C8Meta } from "/webapp/pages/callback.vue?macro=true";
import { default as _91_46_46_46slug_93OKRIXOpmHIYLFvhhIxsEjGi0XWYKVQbuMeFUnw_45xo4MMeta } from "/webapp/pages/[...slug].vue?macro=true";
import { default as portaIF_45ZvT4ex2xg3KVS3fqilFlKMSE2OF7C5RQW_45PnWFAcMeta } from "/webapp/pages/auth/porta.vue?macro=true";
import { default as silent_45renew98gXcb3UxEr0Qq2qHtUSADJ8jBMSyo3QNt6O_zz39tcMeta } from "/webapp/pages/silent-renew.vue?macro=true";
import { default as _91_46_46_46slug_93p_ovwd3gV8NznY0oY_yHZkpzngN5CICkD1BzhK6uVEwMeta } from "/webapp/pages/embed/[...slug].vue?macro=true";
import { default as _91_46_46_46plan_93auSG_mfvHP73idayShPAHxzZlDji1h63UXgfvNlGRx4Meta } from "/webapp/pages/checkout/[...plan].vue?macro=true";
export default [
  {
    name: "error",
    path: "/error",
    component: () => import("/webapp/pages/error.vue")
  },
  {
    name: "callback",
    path: "/callback",
    component: () => import("/webapp/pages/callback.vue")
  },
  {
    name: "slug",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93OKRIXOpmHIYLFvhhIxsEjGi0XWYKVQbuMeFUnw_45xo4MMeta || {},
    component: () => import("/webapp/pages/[...slug].vue")
  },
  {
    name: "auth-porta",
    path: "/auth/porta",
    meta: portaIF_45ZvT4ex2xg3KVS3fqilFlKMSE2OF7C5RQW_45PnWFAcMeta || {},
    component: () => import("/webapp/pages/auth/porta.vue")
  },
  {
    name: "silent-renew",
    path: "/silent-renew",
    component: () => import("/webapp/pages/silent-renew.vue")
  },
  {
    name: "embed-slug",
    path: "/embed/:slug(.*)*",
    component: () => import("/webapp/pages/embed/[...slug].vue")
  },
  {
    name: "checkout-plan",
    path: "/checkout/:plan(.*)*",
    meta: _91_46_46_46plan_93auSG_mfvHP73idayShPAHxzZlDji1h63UXgfvNlGRx4Meta || {},
    component: () => import("/webapp/pages/checkout/[...plan].vue")
  }
]